module.exports = __webpack_public_path__ + "img/1.571ad422.jpg";